import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const ViewNISParticipantWrapper = styled.div`
  .separator-space {
    margin: 24px 0px;

    ${responsive.MOBILE`
       margin: 16px 8px;
      `}
  }
  a h3.Link {
    text-decoration: underline;
    color: ${COLORS.primary_light_blue};
  }

  .value-style {
    word-wrap: break-word;
  }
`;
